"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = () => ({
    root: {
        width: '100%'
    },
    buttonWrapper: {
        display: 'flex',
        padding: '14',
        flexGrow: 1,
        justifyContent: 'flex-end'
    },
    button: {
        marginLeft: 14
    }
});
//# sourceMappingURL=writer.style.js.map